module.exports = __webpack_public_path__ + "static/Brain-90c81f3c5b0177ea658f16f0539e8bc6.svg";